export const HEADER_HEIGHT = 56;

export const TAGS_FILTER_LOCAL_STORAGE_KEY = "tagsListMinimized";

export const CHAT_PAGE_WIDTH = 800;

export const PRIVATE_APPLE_ID = "privaterelay.appleid.com";

export const SHOULD_SHOW_FTUE_MODAL_LOCAL_STORAGE_KEY = "shouldShowFTUEModal";
export const HOMEPAGE_RECOMMENDATIONS_LOCAL_STORAGE_KEY_PREFIX = "recombee";

export const RECOMMENDED_PAGE_RECOMMENDATIONS_LOCAL_STORAGE_KEY_PREFIX = "recombee_navigate";

export const NSFW_LOCAL_STORAGE_KEY = "nsfw";
export const SFW_LOCAL_STORAGE_KEY = "sfw";

export const DEFAULT_HOMEPAGE_RECOMMENDATIONS_NUM = 24;
export const HOMEPAGE_RECOMMENDATIONS_ALLOWED_TO_REMOVE_NUM = 3;

export const DEFAULT_RECOMMENDED_PAGE_RECOMMENDATIONS_NUM = 602;
export const RECOMMENDED_PAGE_RECOMMENDATIONS_ALLOWED_TO_REMOVE_NUM = 15;

export const MY_CHATS_CONVERSATION_LIMIT = 25;

export const TYPESENSE_NODE_PORT = 443;
export const TYPESENSE_NODE_PROTOCOL = "https";

export const TYPESENSE_SEARCH_CUTOFF_MS = 10000;
export const TYPESENSE_CACHE_SEARCH_RESULTS_SECONDS = 300;
export const TYPESENSE_CONNECTION_TIMEOUT_SECONDS = 20;
export const TYPESENSE_HEALTHCHECK_INTERVAL_SECONDS = 5;
export const TYPESENSE_RETRY_INTERVAL_SECONDS = 0.5;
export const TYPESENSE_NUM_RETRIES = 8;
export const TYPESENSE_TEXT_MATCH_BUCKETS = 3;
export const TYPESENSE_TEXT_MATCH_SORT_PREFIX = `_text_match(buckets: ${TYPESENSE_TEXT_MATCH_BUCKETS}):desc`;
export const THREE_SECONDS = 3000;
export const TEN_SECONDS = 10000;
export const HALF_A_SECOND = 500;
